import React from 'react';
// Defined in general.js
/* global toast scrollToPageTop Uri */
// Replacement for TabsMixin.js
import useMobileStatus from '../useMobileStatus.js';


function useTabs(
    convertToApiURL, validTabs, getTabName, additionalDataHandling,
) {
    const initialLoad = React.useRef(true);
    const [isMobile] = useMobileStatus();
    const [activeTabName, setActiveTabName] = React.useState();
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState();
    const [url, setUrl] = React.useState(location.href);

    const requestDataAndScroll = React.useCallback(function (apiUrl, tab, scrollAfterLoading = true) {
        $.ajax({
            url: apiUrl,
            cache: true,
            dataType: 'json',
            success: (newData) => {
                additionalDataHandling && additionalDataHandling(newData, tab);
                setData(newData);
                setLoading(false);
            },
            error: () => {
                toast('There was a problem loading more results. Please try again later.');
                setLoading(false);
            },
        });

        if (initialLoad.current) {
            initialLoad.current = false;
        } else if (!isMobile && scrollAfterLoading) {
            // we need to account for the floating give bar
            const topPos = $('#tabs').is(':visible')
                ? $('#tabs').offset().top - 100
                : 0;

            scrollToPageTop(topPos);
        }
    }, [additionalDataHandling, isMobile]);

    /**
     * Changes the page URL and loads the relevant data.
     */
    const changeURL = React.useCallback(function (url) {
        if (loading) {
            return;
        }

        const tabName = getTabName(url);
        setActiveTabName(tabName);
        setUrl(url);
        setLoading(true);
        history.replaceState(null, null, url);
        const tab = validTabs.get(tabName);
        requestDataAndScroll(convertToApiURL(url, tab), tab);
    }, [loading, getTabName, requestDataAndScroll, validTabs, convertToApiURL]);

    /**
     * Activates a tab and loads its data.
     */
    const activateTab = React.useCallback(function (tabName) {
        const newTab = validTabs.get(tabName);

        changeURL(new Uri(url)
            .delete('page')
            .delete('active')
            .delete('historical')
            .delete('projects') // [BGK, 2016-12-13: currently only used for Teacher Profile tabs]
            .delete('fundedProjectsYear') // unique to Projects tab on Teacher Profile page
            .delete('supporters')
            .add(newTab.get('paramName'), 'true')
            .toString());
    }, [changeURL, url, validTabs]);

    const closeTab = React.useCallback(function () {
        setActiveTabName(null);
        setData(null);
    }, []);

    return { activeTabName, loading, data, url, isMobile, activateTab, changeURL, closeTab, requestDataAndScroll };
}
export default useTabs;
